import React from 'react'
import ReactDOM from 'react-dom/client'
import { AppRouter } from './AppRouter'
import './styles/index.css'
import { initSentry, SentryErrorBoundary } from './config/sentry'
import './i18n'

// Initialize Sentry error tracking
initSentry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={<div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>Oops! Something went wrong</h1>
      <p>Our team has been notified. Please refresh the page.</p>
      <button onClick={() => window.location.reload()}>Refresh</button>
    </div>}>
      <AppRouter />
    </SentryErrorBoundary>
  </React.StrictMode>,
)
